/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SitemapItem
 */
export interface SitemapItem {
  /**
   *
   * @type {string}
   * @memberof SitemapItem
   */
  url: string
  /**
   *
   * @type {Date}
   * @memberof SitemapItem
   */
  lastModified?: Date
  /**
   *
   * @type {string}
   * @memberof SitemapItem
   */
  title: string
  /**
   *
   * @type {Array<SitemapItem>}
   * @memberof SitemapItem
   */
  children?: Array<SitemapItem>
}

/**
 * Check if a given object implements the SitemapItem interface.
 */
export function instanceOfSitemapItem(value: object): value is SitemapItem {
  if (!('url' in value) || value['url'] === undefined) return false
  if (!('title' in value) || value['title'] === undefined) return false
  return true
}

export function SitemapItemFromJSON(json: any): SitemapItem {
  return SitemapItemFromJSONTyped(json, false)
}

export function SitemapItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SitemapItem {
  if (json == null) {
    return json
  }
  return {
    url: json['url'],
    lastModified:
      json['lastModified'] == null ? undefined : json['lastModified'],
    title: json['title'],
    children:
      json['children'] == null
        ? undefined
        : (json['children'] as Array<any>).map(SitemapItemFromJSON),
  }
}

export function SitemapItemToJSON(value?: SitemapItem | null): any {
  if (value == null) {
    return value
  }
  return {
    url: value['url'],
    lastModified: value['lastModified'],
    title: value['title'],
    children:
      value['children'] == null
        ? undefined
        : (value['children'] as Array<any>).map(SitemapItemToJSON),
  }
}
